import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Experience() {
  return (
    <Container fluid className="about-section">
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Experiencia</strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={8}>
            <div className="timeline">
              <div className="timeline-item">
                <h4 className="resume-title">Full Stack Developer</h4>
                <p className="resume-period">
                  Mar. 2026 – Actualidad · Freelance · Remoto
                </p>
                <p
                  style={{
                    color: "#c9d1d9",
                    textAlign: "justify",
                    marginTop: "10px",
                  }}
                >
                  Desarrollo de aplicaciones web y móviles para clientes
                  independientes, gestionando todo el ciclo de vida del
                  proyecto.
                </p>
                <ul
                  style={{
                    color: "#c9d1d9",
                    paddingLeft: "20px",
                    textAlign: "justify",
                    marginTop: "12px",
                  }}
                >
                  <li style={{ paddingBottom: "5px" }}>
                    Desarrollo de aplicaciones web y móviles utilizando
                    tecnologías frontend y backend.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Diseño e integración de APIs REST para comunicación entre
                    servicios y aplicaciones.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Implementación de sistemas de autenticación, manejo de
                    usuarios y bases de datos.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Optimización de rendimiento, mantenimiento y mejora de
                    funcionalidades existentes.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Desarrollo de interfaces dinámicas enfocadas en experiencia
                    de usuario y usabilidad.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Resolución de problemas técnicos, debugging y adaptación de
                    soluciones según requerimientos del cliente.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Trabajo con metodologías ágiles y control de versiones para
                    organización y escalabilidad de proyectos.
                  </li>
                </ul>
              </div>
              <div className="timeline-item">
                <h4 className="resume-title">Full Stack Developer</h4>
                <p className="resume-period">
                  Mar. 2024 - Jul. 2025 · Instituto Superior Politécnico Córdoba
                  · Remoto
                </p>
                <p
                  style={{
                    color: "#c9d1d9",
                    textAlign: "justify",
                    marginTop: "10px",
                  }}
                >
                  Durante mi práctica profesionalizante, participé activamente
                  en proyectos de desarrollo web y móvil aplicando metodologías
                  ágiles (SCRUM) y tecnologías modernas.
                </p>
                <ul
                  style={{
                    color: "#c9d1d9",
                    paddingLeft: "20px",
                    textAlign: "justify",
                    marginTop: "12px",
                  }}
                >
                  <li style={{ paddingBottom: "5px" }}>
                    Creación de una aplicación web SPA con Angular, aplicando
                    diseño modular y buenas prácticas.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Implementación de un sitio web estático con HTML, CSS,
                    TypeScript y Bootstrap, priorizando accesibilidad y UX/UI.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Desarrollo de API REST escalables utilizando Python con
                    Django, garantizando seguridad y eficiencia.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Diseño y optimización de bases de datos relacionales en
                    MySQL, asegurando integridad y eficiencia en las consultas.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Construcción de una aplicación móvil nativa con Java y
                    Android Studio, integrando login y registro, así como
                    paneles de gestión para usuarios y administradores.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Aplicación de pruebas unitarias y automatizadas, reduciendo
                    errores críticos en etapas tempranas del desarrollo.
                  </li>
                  <li style={{ paddingBottom: "5px" }}>
                    Uso de Git y GitHub para control de versiones y
                    colaboración, en flujos de trabajo ágiles.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>

        <h1 className="project-heading">
          <strong className="purple">Educación</strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={8}>
            <div className="timeline">
              <div className="timeline-item">
                <h4 className="resume-title">
                  Tecnicatura Universitaria en Desarrollo de Software
                </h4>
                <p className="resume-period">
                  Universidad del Chubut · Mar. 2026 – Actualidad
                </p>
              </div>
              <div className="timeline-item">
                <h4 className="resume-title">
                  Tecnicatura Superior en Desarrollo Web y Aplicaciones
                  Digitales
                </h4>
                <p className="resume-period">
                  ISPC Instituto Superior Politécnico Córdoba · Mar. 2023 – Jul.
                  2025
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Experience;
